import React from 'react';
import { List } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';


import './analytics.css';

const TinyTable = (props) => {
  const { loading, title, data, onSelect } = props;

  return (
    <List
      pagination = {true}
      loading={loading?{indicator:<LoadingOutlined style={{ fontSize: 24 }} spin />}:false}
      className="tinytable"
      size="small"
      header={<div className="header">
        <span className="header1">{title[0]}</span>
        <span className="header2">{title[1]}</span>
      </div>}
      dataSource={data}
      renderItem={(item) =>
        <div>
          <div className={onSelect?'row select':'row'} onClick={onSelect && onSelect.bind(this,item)}>
            <span className="item1">{item.name}</span>
            <span className="item2">{(item.value).toLocaleString('en-US')}</span>
          </div>
          {item.percent &&
            <div  className="percent">
              <div  className="percent-line" style={{width:`${item.percent*100}%`}}>
              </div>
            </div>
          }
        </div>
      }
    />
  );
};

export default TinyTable;
